var ElcServiceBus;
var ServiceBusTopics;
var site;

ElcServiceBus || window.ElcServiceBus;
ServiceBusTopics = ServiceBusTopics || window.ServiceBusTopics;
site = window.site || {};
page_data = page_data || {};

(function ($) {
  Drupal.behaviors.foundationFinderResultsPanelV1 = {
    productHTML: '',
    isMobile: false,
    backOrderEnabled: Drupal.settings?.elc_ecom?.prodcatConfig?.backorder?.enabled,
    attach: function (context) {
      var self = this;
      var $modules = $('.js-foundation-finder-results', context);

      self.isMobile = window.innerWidth <= 1024;

      $modules.each(function () {
        var $module = $(this);

        self.getDom($module);
        self.getProps($module);
        self.setInits($module);
        self.setListeners($module);
      });
    },
    getDom: function ($module) {
      $module.nodes = {
        quickMatchResults: $('.js-quick-match-button', $module),
        quickMatch: $('.js-foundation-finder-results__quick-match-cta', $module),
        quickMatchProducts: $('.js-product-picker-dropdown-options-list', $module),
        quickMatchSkus: $('.js-product-shade-picker-dropdown-options-list', $module),
        quickMatchSelectedProduct: $('.js-product-picker-dropdown-name', $module),
        quickMatchSelectedSku: $('.js-product-shade-picker-dropdown-shade-name', $module),
        quickMatchSelectedHex: $('.js-product-shade-picker-dropdown-shade-hex-icon', $module),
        quickMatchClose: $('.js-quick-match-close', $module),
        quickMatchModal: $('.js-quick-match-modal', $module),
        panels: $('.js-foundation-finder-results-panel', $module),
        noResults: $('.js-foundation-finder-results__no-results-wrapper', $module),
        noResultsReset: $('.js-foundation-finder-results__no-results__reset', $module),
        products: $('.js-foundation-finder-results-panel-products', $module),
        foundationPanel: $('.js-foundation-finder-results-panel-foundation', $module),
        foundationProducts: $('.js-foundation-finder-results-panel-foundation-products', $module),
        allFoundationSkus: undefined,
        concealerPanel: $('.js-foundation-finder-results-panel-concealer', $module),
        concealerProducts: $('.js-foundation-finder-results-panel-concealer-products', $module),
        lipstickPanel: $('.js-foundation-finder-results-panel-lipstick', $module),
        lipstickProducts: $('.js-foundation-finder-results-panel-lipstick-products', $module),
        primerPanel: $('.js-foundation-finder-results-panel-primer', $module),
        primerProducts: $('.js-foundation-finder-results-panel-primer-products', $module),
        productPartial: undefined,
        carousels: [
          $('.js-foundation-finder-results-panel-foundation', $module),
          $('.js-foundation-finder-results-panel-concealer', $module),
          $('.js-foundation-finder-results-panel-lipstick-products', $module),
          $('.js-foundation-finder-results-panel-primer-products', $module)
        ]
      };
      $module.nodes.noResultsReset.text($('.js-foundation-finder--quiz__start-over').text());
    },
    getProps: function ($module) {
      $module.props = {
        colorFamily: {
          nude_color: $module.data('colorFamilyNudeLabel'),
          red_color: $module.data('colorFamilyRedLabel'),
          orange_color: $module.data('colorFamilyOrangeLabel'),
          pink_color: $module.data('colorFamilyPinkLabel'),
          purple_color: $module.data('colorFamilyPurpleLabel')
        },
        productData: undefined,
        answers: undefined,
        allSkuData: [],
        results: [],
        primerIds: $module.data('primerProductIds')
          ? $module.data('primerProductIds').split(',')
          : [],
        primerProductData: []
      };
    },
    parseProductData: function ($module, data, $panel) {
      const self = this;
      var products = [];

      if (data[0]) {
        products = data[0];
        self.renderPrimers($module, products, $panel);
      }
    },
    gatherAllSkus: function ($module) {
      $module.props.allSkuData = Object.entries($module.props.productData).reduce(
        (acc, product) => {
          const validSkus = product[1].skus.filter(
            (sku) => Object.prototype.hasOwnProperty.call(sku, 'SKU_NOTES') && sku['SKU_NOTES']
          );
          return acc.concat(validSkus);
        },
        []
      );
    },

    populateQuickSelect: function ($module) {
      $module.nodes.quickMatchProducts.html('');
      $module.nodes.quickMatchSelectedProduct.html('');
      $module.nodes.quickMatchSkus.html('');
      $module.nodes.quickMatchSelectedSku.html('');
      $module.nodes.quickMatchSelectedHex.html('');
      Object.entries($module.props.productData).forEach(function (product, index) {
        const productID = product[1]['PRODUCT_ID'];
        const productName = product[1]['PROD_RGN_NAME'];
        const productSub = product[1]['PROD_RGN_SUBHEADING'];
        const productHtml = `
  <li role="option" class="product-picker-dropdown-option js-product-picker-dropdown-option" 
      title="${productName}" 
      data-prod-id="${productID}">
    ${productName} ${productSub}
  </li>`;

        $module.nodes.quickMatchProducts.append(productHtml);

        if (index === 0) {
          $module.nodes.quickMatchSelectedProduct
            .html(`${productName} ${productSub}`)
            .data('prod-id', productID);
        }
      });
      const selectedProd = $module.nodes.quickMatchSelectedProduct.data('prod-id');

      $module.props.allSkuData.forEach(function (value, index) {
        const skuHtml = `
  <li role="option" class="product-shade-picker-dropdown-option js-product-shade-picker-dropdown-option${
    selectedProd === value.PRODUCT_ID ? '' : ' hidden'
  }" 
      title="${value.SHADENAME}" 
      data-sku-id="${value.SKU_BASE_ID}" 
      data-prod-id="${value.PRODUCT_ID}" 
      data-hex-id="${value.HEX_VALUE_STRING}">
    <div class="product-shade-picker-dropdown-shade-hex">
      <div class="product-shade-picker-dropdown-shade-hex-icon" style="background-color:${
        value.HEX_VALUE_STRING
      }"></div>
    </div>
    ${value.SHADENAME}
  </li>`;

        $module.nodes.quickMatchSkus.append(skuHtml);
        if (index === 0) {
          $module.nodes.quickMatchSelectedSku
            .html(value.SHADENAME)
            .data('sku-id', value.SKU_BASE_ID);
          $module.nodes.quickMatchSelectedHex.css('background-color', value.HEX_VALUE_STRING);
        }
      });

      // Refresh specific dom elements due to adhoc html insertion.
      $module.nodes.quickMatchProductsListener = $('.js-product-picker-dropdown-option', $module);
      $module.nodes.quickMatchProductsWrapper = $('.js-product-picker-dropdown-wrapper', $module);
      $module.nodes.quickMatchProductsArrow = $('.js-product-picker-dropdown-arrow', $module);
      $module.nodes.quickMatchSkusListener = $('.js-product-shade-picker-dropdown-option', $module);
      $module.nodes.quickMatchSkusWrapper = $('.js-product-shade-picker-dropdown-wrapper', $module);
      $module.nodes.quickMatchSkusArrow = $(
        '.js-product-shade-picker-dropdown-shade-arrow',
        $module
      );
      $module.nodes.quickMatchSkusItems = $(
        '.js-product-shade-picker-dropdown-options-list li',
        $module
      );
    },
    formatProductData: function ($module) {
      var tempProducts = {};

      Object.entries($module.props.productData).forEach(function (product) {
        var productID = product[1]['PRODUCT_ID'];

        product[1]['skus'] = [];
        if (product[1].hasOwnProperty(productID)) {
          tempProducts[productID].push(product[1]);
        } else {
          tempProducts[productID] = product[1];
        }
      });
      $module.props.productData = tempProducts;
    },
    setProductData: function ($module) {
      const self = this;

      if (!page_data?.['custom-mpp']?.['products']) {
        return false;
      } else {
        $module.props.productData = $.extend(true, {}, page_data['custom-mpp']['products']);
        self.gatherAllSkus($module);
        self.formatProductData($module);
        self.populateQuickSelect($module);
      }
    },

    fetchProductData: function ($module, productIds, $panel) {
      const self = this;
      var promises = {};

      try {
        const queryOptions = {
          filterBy: {
            productIds: productIds
          }
        };

        promises.products = ElcServiceBus.query(
          ServiceBusTopics.queries.GET_PRODUCT_DATA,
          queryOptions
        );
        // Requires the promises.products to return data even if not defined.
        Promise.all([promises.products, promises.skus]).then((data) => {
          self.parseProductData($module, data, $panel);
        });
      } catch (e) {
        console.error(e);
      }
    },
    fetchProductSkuData: function ($module, productIds, $panel, mergeSkus) {
      const self = this;
      var promises = {};

      try {
        promises.skus = ElcServiceBus.query(ServiceBusTopics.queries.GET_SKUS, productIds);
        // Requires the promises.products to return data even if not defined.
        Promise.all([promises.products, promises.skus]).then((data) => {
          const parentProducts = [];
          if (data[1]) {
            for (const key in data[1]) {
              if (data[1].hasOwnProperty(key) && data[1][key].parentProduct) {
                if (!mergeSkus) {
                  let translatedColor = '';
                  let shadeFamily = [];
                  let availableSkusArray = Array.from(data[1][key].parentProduct.availableSkus);

                  availableSkusArray = availableSkusArray.filter((sku) => sku.skuId === key);
                  if (availableSkusArray.length > 0) {
                    shadeFamily = Array.from(availableSkusArray[0].colorFamily);
                  }
                  if (shadeFamily.length > 0) {
                    translatedColor = $module.props.colorFamily[shadeFamily[0].value];
                  }
                  let newParentProduct = {
                    ...data[1][key].parentProduct,
                    skus: availableSkusArray,
                    productBadge: translatedColor,
                    product_badge: translatedColor
                  };
                  data[1][key].parentProduct = newParentProduct;
                }
                parentProducts.push(data[1][key].parentProduct);
              }
            }
            if (mergeSkus) {
              const uniqueProducts = [];
              const productIds = new Set();
              for (const product of parentProducts) {
                if (!productIds.has(product.productId)) {
                  productIds.add(product.productId);
                  uniqueProducts.push(product);
                }
              }
              self.parseProductData($module, [uniqueProducts], $panel);
            } else {
              self.parseProductData($module, [parentProducts], $panel);
            }
          }
        });
      } catch (e) {
        console.error(e);
      }
    },
    reinitializeProductPartials: function ($module) {
      const self = this;
      self.initCarousels($module);
      $module.find('.js-sku-brief-editorial').each(function () {
        $.event.trigger({
          type: 'product_partial:product_reinit',
          payload: {
            $el: $(this)
          }
        });
      });
    },
    setInits: function ($module) {
      // eslint-disable-next-line no-unused-vars
      const self = this;

      self.getPartial($module);
      self.setProductData($module);
    },
    setQuickSelectInits: function ($module) {
      // Select product.
      $('.js-product-picker-dropdown-option').on('click', function () {
        $module.nodes.quickMatchProductsWrapper.removeClass('list-expanded');

        var prodBaseId = $(this).data('prod-id');

        $module.nodes.quickMatchSelectedProduct.html($(this).html());
        $module.nodes.quickMatchProducts.hide();
        $module.nodes.quickMatchProductsArrow.removeClass('open');

        // Hide unrelated shades.
        var shadeCount = 0;

        $module.nodes.quickMatchSkusItems.each(function () {
          const self = this;

          if ($(self).data('prod-id') !== prodBaseId) {
            $(self).addClass('hidden');
          } else {
            // Reset selected sku to first.
            if (shadeCount === 0) {
              const skuBaseId = parseInt($(self).data('sku-id') || 0, 10);

              $module.nodes.quickMatchSelectedSku.html($(self).text()).data('sku-id', skuBaseId);
              $module.nodes.quickMatchSelectedHex.css('background-color', $(self).data('hex-id'));
            }
            $(self).removeClass('hidden');
            shadeCount++;
          }
        });
      });

      // Select shade.
      $('.js-product-shade-picker-dropdown-option').on('click', function () {
        $module.nodes.quickMatchSkusWrapper.removeClass('list-expanded');
        const skuBaseId = parseInt($(this).data('sku-id') || 0, 10);

        $module.props.allSkuData.forEach(function (sku) {
          if (skuBaseId === sku.SKU_BASE_ID) {
            $module.nodes.quickMatchSelectedSku.html(sku.SHADENAME).data('sku-id', skuBaseId);
            $module.nodes.quickMatchSelectedHex.css('background-color', sku.HEX_VALUE_STRING);
            $module.nodes.quickMatchSkus.hide();
            $module.nodes.quickMatchSkusArrow.removeClass('open');
          }
        });
      });
    },
    setListeners: function ($module) {
      const self = this;

      $module.nodes.quickMatchClose.on('click', function () {
        $('body').css('overflow', 'auto');
        $module.nodes.quickMatchModal.addClass('hidden');
        $module.nodes.quickMatchSkus.hide();
        $module.nodes.quickMatchSkusArrow.removeClass('open');
        $module.nodes.quickMatchSkusWrapper.removeClass('list-expanded');
        $module.nodes.quickMatchProducts.hide();
        $module.nodes.quickMatchProductsArrow.removeClass('open');
        $module.nodes.quickMatchProductsWrapper.removeClass('list-expanded');
        self.populateQuickSelect($module);
        self.setQuickSelectInits($module);
      });

      self.setQuickSelectInits($module);
      // Open/Close products dropdown.
      $module.nodes.quickMatchProductsWrapper.on('click', function () {
        if ($module.nodes.quickMatchProducts.is(':hidden')) {
          $module.nodes.quickMatchSkus.hide();
          $module.nodes.quickMatchSkusArrow.removeClass('open');
          $module.nodes.quickMatchSkusWrapper.removeClass('list-expanded');
          $module.nodes.quickMatchProductsArrow.addClass('open');
          $module.nodes.quickMatchProducts.show();
          $module.nodes.quickMatchProductsWrapper.addClass('list-expanded');
        } else {
          $module.nodes.quickMatchProducts.hide();
          $module.nodes.quickMatchProductsArrow.removeClass('open');
          $module.nodes.quickMatchProductsWrapper.removeClass('list-expanded');
        }
      });

      // Open/Close shades dropdown.
      $module.nodes.quickMatchSkusWrapper.on('click', function () {
        if ($module.nodes.quickMatchSkus.is(':hidden')) {
          $module.nodes.quickMatchProducts.hide();
          $module.nodes.quickMatchProductsArrow.removeClass('open');
          $module.nodes.quickMatchProductsWrapper.removeClass('list-expanded');
          $module.nodes.quickMatchSkusArrow.addClass('open');
          $module.nodes.quickMatchSkus.show();
          $module.nodes.quickMatchSkusWrapper.addClass('list-expanded');
        } else {
          $module.nodes.quickMatchSkus.hide();
          $module.nodes.quickMatchSkusArrow.removeClass('open');
          $module.nodes.quickMatchSkusWrapper.removeClass('list-expanded');
        }
      });

      $module.nodes.quickMatchResults.on('click', function () {
        $('body').css('overflow', 'auto');
        self.clearProducts($module);
        const selectedSKU = $module.nodes.quickMatchSelectedSku.data('sku-id');
        const skuOverride = `SKU${selectedSKU}`;

        self.answerCheck($module, skuOverride);
        self.showPrimers($module);
        $module.nodes.quickMatchModal.addClass('hidden');
        $.event.trigger({
          type: 'foundation_finder_results_panel:init_quickMatchResults'
        });
      });

      // On resize, ensure listeners are reapplied.
      $(window).on(
        'resize',
        _.debounce(function () {
          self.reinitializeProductPartials($module);
        }, 100)
      );

      $module.nodes.noResultsReset.once().on('click', function () {
        $.event.trigger({
          type: 'foundation_finder_quiz:start_over_secondary_click'
        });
      });

      $(document).on('foundation_finder_quiz:init_quickMatch', function () {
        $module.nodes.quickMatchModal.removeClass('hidden');
        $('body').css('overflow', 'hidden');
      });

      $(document).on('foundation_finder_quiz:init_results', function (e) {
        $module.props.answers = e.payload['answers'];
        self.formatAnswers($module);
        self.answerCheck($module);
        self.showPrimers($module);
        setTimeout(function () {
          self.initCarousels($module);
          $module.find('.js-sku-brief-editorial').each(function () {
            $.event.trigger({
              type: 'product_partial:product_reinit',
              payload: {
                $el: $(this)
              }
            });
          });
        }, 3000);
      });
      $(document).on('foundation_finder_quiz:nav_item_click', function () {
        self.clearProducts($module);
      });
      $(document).on('foundation_finder_quiz:start_over_click', function () {
        self.clearProducts($module);
      });
      $(document).on('product_partial:sku_slick_init', function (e) {
        var $product = e.payload['$el'].closest('.js-sku-brief-editorial');
        var $skus = e.payload['$el'].find('.js-sku-brief-editorial-shade');
        var $sku;
        var $selected;

        $skus.each(function () {
          $sku = $(this);
          $sku.on('click', function (e) {
            $selected = $(this);
            skuId = $selected.data('productSkuBaseId');
            skuNotes = $selected.data('skuNotes');
            self.splitConcealerLipstick($module, $selected.data('skuNotes'));
          });
        });

        if ($product.hasClass('js-init-non-active')) {
          $skus.eq(0).removeClass('active');
        }
      });

      $(document).on('product_partial:atb_status_change', function (e) {
        var $currentSku = e.payload['$currentSku'];
        var isFoundationPanel = $currentSku.closest(
          '.js-foundation-finder-results-panel-foundation-products'
        )
          ? true
          : false;

        if (isFoundationPanel) {
          if (!$module.nodes.allFoundationSkus) {
            $module.nodes.allFoundationSkus = $module.nodes.foundationProducts.find(
              '.js-sku-brief-editorial-shade'
            );
          }
          $module.nodes.allFoundationSkus.removeClass('active');
          $currentSku.addClass('active');
        }
      });
    },
    clearProducts: function ($module) {
      $module.nodes.products.html('');
      $module.nodes.panels.removeClass('active');
      $module.nodes.noResults.removeClass('active');
      $module.nodes.products.removeClass('slick-slider');
      $module.nodes.products.removeClass('slick-initialized');
      Object.entries($module.props.productData).forEach(function (product) {
        product[1]['skus'] = [];
      });
    },
    initCarousels: function ($module) {
      const self = this;
      var $currentCarousel;
      // Todo test without any of below to see if it works nad remove if so
      try {
        $module.nodes.carousels.forEach(function (carousel) {
          const matchingNodes = carousel.find('.js-sku-brief-editorial');
          // eslint-disable-next-line padding-line-between-statements
          matchingNodes.css('display', '');
          // Todo any of this needed?
          $currentCarousel = carousel.find('.slick-initialized');
          if ($currentCarousel.hasClass('slick-initialized')) {
            $currentCarousel.slick('slickGoTo', 0);
            $currentCarousel.slick('setPosition');
          }
        });
      } catch (e) {
        setTimeout(function () {
          self.initCarousels($module);
        }, 2000);
      }
    },
    showPrimers: function ($module) {
      $module.nodes.primerPanel.addClass('active');
    },
    getPartial: function ($module) {
      if (!$module.nodes.productPartial) {
        $module.nodes.productPartial = $(
          'script.inline-template[path="/products/_partials/product_partial/product-partial.tmpl"]'
        ).html();
      }
    },
    answerCheck: function ($module, skuOverride) {
      const self = this;

      $module.props.allSkuData.forEach(function (sku) {
        var currentScore = 0;
        var prod = $module.props.productData[sku['PRODUCT_ID']];
        var coverage = prod['COVERAGE'] || '';
        var finish = prod['FINISH'] || '';
        var concerns = prod['SKIN_CONCERN'] || [];
        var concerns1 = prod['SKIN_CONCERN_1'] || '';
        var productCoverages = coverage.replace(/\s+/g, '').split(',');
        var productFinishes = finish.replace(/\s+/g, '').split(',');
        var productConerns;

        if (concerns.length === 0) {
          concerns.push(concerns1);
        }
        productConerns = concerns[0].replace(/\s+/g, '').split(',');
        if (skuOverride) {
          if (skuOverride === sku['SKU_ID']) {
            currentScore = 5;
          }
        } else {
          productCoverages.forEach(function (productCoverage) {
            if (
              $module.props.answers['coverage']?.toLowerCase() === productCoverage.toLowerCase()
            ) {
              // Coverage passes at product level.
              currentScore++;
              return false;
            }
          });

          productFinishes.forEach(function (productFinish) {
            if ($module.props.answers['finish']?.toLowerCase() === productFinish.toLowerCase()) {
              // Finish passes at product level.
              currentScore++;
              return false;
            }
          });

          productConerns.forEach(function (productConern) {
            if (
              $module.props.answers['skin_concern']?.toLowerCase() === productConern.toLowerCase()
            ) {
              // Concern passes at product level.
              currentScore++;
              return false;
            }
          });
          if (sku['UNDERTONE']) {
            if (
              $module.props.answers['undertone']?.toLowerCase() === sku['UNDERTONE'].toLowerCase()
            ) {
              // Undertone passes at sku level.
              currentScore++;
            }
          }
          if (sku['SHADE_NUMBER']) {
            if ($module.props.answers['shade_number'] === sku['SHADE_NUMBER']) {
              // Shade_number passes at sku level.
              currentScore++;
            }
          }
        }
        if (currentScore === 5) {
          prod['skus'].push(sku);
        }
      });

      self.renderProducts($module);
      self.fetchProductData($module, $module.props.primerIds, $module.nodes.primerProducts);
    },
    splitConcealerLipstick: function ($module, skuNotes) {
      const self = this;
      var split = skuNotes.split('|');
      var concealerIds;
      var lipstickIds;

      if (split[0]) {
        concealerIds = split[0].split(':');
      }
      if (split[1]) {
        lipstickIds = split[1].split(':');
      }

      if (concealerIds) {
        self.fetchProductSkuData($module, concealerIds, $module.nodes.concealerProducts, true);
        $module.nodes.concealerPanel.addClass('active');
      }
      if (lipstickIds) {
        self.fetchProductSkuData($module, lipstickIds, $module.nodes.lipstickProducts, false);
        $module.nodes.lipstickPanel.addClass('active');
      }
    },
    renderProducts: function ($module) {
      const self = this;
      var rendered;
      var $rendered;
      var productCount = 0;

      Object.entries($module.props.productData).forEach(function (product) {
        if (product[1]['skus'].length > 0) {
          productCount++;

          if (product[1].skus.length > 0) {
            product[1]['shadeNameFormatted'] =
              product[1].skus[0]['SHADENAME'].replace(/ /g, '_') || '';
          }
          rendered = Mustache.render($module.nodes.productPartial, product[1]);
          $rendered = $(rendered);
          $module.nodes.foundationProducts.append($rendered);
          if ($rendered.find('.js-price-per-unit').html() === '') {
            $rendered.find('.js-sku-brief-editorial-divider').addClass('hidden');
            $rendered.find('.js-sku-brief-editorial-unit').addClass('hidden');
          }
          if (productCount > 1) {
            $rendered.addClass('js-init-non-active');
          }
          self.splitConcealerLipstick($module, product[1]['skus'][0]['SKU_NOTES']);
          $.event.trigger({
            type: 'product_partial:product_reinit',
            payload: {
              $el: $rendered
            }
          });
          $module.nodes.foundationPanel.addClass('active');
        }
      });

      // No products, so display no results message.
      if (productCount == 0) {
        $module.nodes.noResults.addClass('active');
        $.event.trigger({
          type: 'foundation_finder_results_panel:product_count_zero'
        });
      }
      try {
        /* if (self.isMobile || productCount > 5) {
          self.generateCarousel($module, $module.nodes.foundationProducts, productCount);
        } */
        self.generateCarousel($module, $module.nodes.foundationProducts, productCount);
      } catch (e) {
        console.error(e);
      }

      if ($module.nodes.concealerProducts.children().length > 0) {
        $module.nodes.concealerPanel.addClass('active');
      }
      if ($module.nodes.primerProducts.children().length > 0) {
        $module.nodes.primerPanel.addClass('active');
      }
    },
    generateCarousel: function ($module, $carousel, productCount) {
      const self = this;

      // Remove margins if in single product mode.
      if ($carousel.hasClass('slick-initialized')) {
        $carousel.slick('unslick');
      }

      $carousel.slick({
        dots: false,
        arrows: true,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 5,
        rtl: site.direction.isRTL,
        prevArrow:
          '<button class="foundation-finder-results__panel-carousel-arrows slide-arrow slick-prev" aria-label="Previous" type="button" style="display: block;"><svg class="icon icon--arrow-left""><use xlink:href="#arrow-left"></use></svg></button>',
        nextArrow:
          '<button class="foundation-finder-results__panel-carousel-arrows slide-arrow slick-next" aria-label="Next" type="button" style="display: block;"><svg class="icon icon--arrow-left""><use xlink:href="#arrow-right"></use></svg></button>',
        responsive: [
          {
            breakpoint: 1366,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: productCount == 1 ? 1 : 1.1,
              centerMode: productCount == 1 ? true : false,
              centerPadding: '34.5px'
            }
          }
        ]
      });
      self.initCarousels($module);
    },
    renderPrimers: function ($module, products, $panel, skuId) {
      var rendered;
      var $rendered;
      const self = this;
      var productCount = 0;

      if ($panel.hasClass('js-foundation-finder-results-panel-products')) {
        $panel.html('');
      }
      products.forEach(function (product) {
        productCount++;
        if (!product.singleSkus) {
          product.singleSkus = product.skus;
        }
        if (product.skus.length > 0 && product.skus[0].shades.length > 0) {
          product['shadeNameFormatted'] = product.skus[0].shades[0].name.replace(/ /g, '_') || '';
        }

        rendered = Mustache.render($module.nodes.productPartial, product);
        $rendered = $(rendered);
        $panel.append($rendered);

        if ($rendered.find('.js-price-per-unit').html() === '') {
          $rendered.find('.js-sku-brief-editorial-divider').addClass('hidden');
          $rendered.find('.js-sku-brief-editorial-unit').addClass('hidden');
        }

        $.event.trigger({
          type: 'product_partial:product_reinit',
          payload: {
            $el: $rendered
          }
        });
      });

      try {
        self.generateCarousel($module, $panel, productCount);
      } catch (e) {
        console.error(e);
      }
    },
    formatAnswers: function ($module) {
      $module.props.answers.skin_concern = $module.props.answers.skin_type;
      delete $module.props.answers.skin_type;
      if ($module.props.answers.skin_concern === 'combination') {
        $module.props.answers.skin_concern = 'normal/combination';
      }
      if ($module.props.answers.finish === 'luminous') {
        $module.props.answers.finish = 'luminous/radiant';
      }

      $module.props.answers.shade_number = $module.props.answers.intensity;
      delete $module.props.answers.intensity;
    },
    onImgSrcError: function (img) {
      img.src = '/media/export/cms/everyday_gifting/placeholder_white.jpg';
    }
  };
})(jQuery);
